<template lang="pug">
.dashboard-header
  .header-content
    span.header-label PANEL PRINCIPAL
    h1
      | Buenos días, {{ nombre }}
    p
      | Aquí tienes el resumen de tus actividades y pendientes.
</template>
<script>
export default {
  name: 'DashboardHeader',
  props: {
    nombre: {
      type: String,
      default: ''
    },
    totalPendientes: {
      type: Number,
      default: 0
    }
  }
}
</script>
<style scoped>
.dashboard-header {
  min-height: 130px;
  padding: 25px 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(
    120deg,
    #565cde,
    #565cde
  );
  border-radius: 12px;
  color: white;
  box-shadow:
    0 4px 15px rgba(33, 37, 41, 0.08);
  margin-bottom: 22px;
  text-align: center;
}
.header-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.header-label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1px;
  opacity: .75;
  text-align: center;
}
h1 {
  margin: 8px 0;
  font-size: 25px;
  font-weight: 400;
  text-align: center;
}
p {
  margin: 0;
  font-size: 13px;
  opacity: .82;
  text-align: center;
}
@media (max-width: 650px) {

  .dashboard-header {
    flex-direction: column;
    align-items: center;
    justify-content: center;

    padding: 22px 15px;

    text-align: center;
  }

  .header-content {
    align-items: center;
    text-align: center;
  }

  h1 {
    font-size: 21px;
  }

}
.header-content {
  width: 100%;
  text-align: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// c_dashboard_header.vue?f12b7396